module.exports = __webpack_public_path__ + "static/media/caption2.15128c9a.png";